module.exports = __webpack_public_path__ + "img/arrow-open.4fbcfa99.svg";